module.exports = __webpack_public_path__ + "img/scotland.29855071.svg";